import { LocaleService } from '../services/storage.service';

function translate(body, trans) {
    const lang = LocaleService.getLocale();
    if (trans == 'full') {
        body = JSON.stringify(body);
        let postfix = '___' + lang;
        let regex = new RegExp(postfix, 'gi');
        if (body) {
            return JSON.parse(body.replace(regex, ''));
        }
    } else if (trans == 'part') {
        body = JSON.stringify(body);
        let postfix = 'label___' + lang;
        let regex = new RegExp(postfix, 'gi');
        if (body) {
            return JSON.parse(body.replace(regex, 'label'));
        }
    } else {
        return body;
    }
}

export default translate;
